// Jun 2026 · Readiness trend — week-over-week movement of the Launch
// readiness score, recorded per business in localStorage (last 12 weeks).
const KEY = "tlb_readiness_trend_v1";

export const epochWeek = (d = new Date()) =>
  Math.floor(d.getTime() / (7 * 24 * 60 * 60 * 1000));

function readAll() {
  try {
    return JSON.parse(window.localStorage.getItem(KEY) || "{}") || {};
  } catch {
    return {};
  }
}

export function recordReadiness(businessId, week, score) {
  if (!businessId || !Number.isFinite(score)) return getReadinessTrend(businessId);
  try {
    const all = readAll();
    const entries = Array.isArray(all[businessId]) ? all[businessId] : [];
    const last = entries[entries.length - 1];
    if (last && last.week === week) {
      last.score = score;
    } else {
      entries.push({ week, score });
    }
    all[businessId] = entries.slice(-12);
    window.localStorage.setItem(KEY, JSON.stringify(all));
    return all[businessId];
  } catch {
    return getReadinessTrend(businessId);
  }
}

export function getReadinessTrend(businessId) {
  const all = readAll();
  return Array.isArray(all[businessId]) ? all[businessId] : [];
}

// Delta of the newest entry vs the most recent PRIOR week entry.
// Returns null until at least two different weeks are recorded.
export function readinessDelta(entries) {
  if (!Array.isArray(entries) || entries.length < 2) return null;
  const last = entries[entries.length - 1];
  const prev = entries[entries.length - 2];
  if (!last || !prev || last.week === prev.week) return null;
  return last.score - prev.score;
}
